import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import {
  ApiClient,
  ApiDocInfo,
  displayTrafficAppStatus,
  getTrafficAppStatusOpt,
  Menu,
  ApiResp
} from "../../api/ApiClient";


import {
  Checkbox,
  Form,
  Modal,
  Toast,
  Typography,
  Descriptions,
  Button,
} from "@douyinfe/semi-ui";
import {
  IconUpload,
  IconDownload,
  IconEyeOpened,
  IconDelete,
  IconFile,
} from "@douyinfe/semi-icons";
import { useState, useEffect } from "react";

const apiClient = ApiClient.getDefault();
export default function TestPage() {

  const [curdApi, setCurdApi] = useState<CrudApi>();
  const [saveLoading, setSaveLoading] = useState(false);
  const [delLoading, setDelLoading] = useState(true);
  const [repLoading, setRepLoading] = useState(true);

  const reset = (status: any) => {
    status = !!status;
    setSaveLoading(status);
    setDelLoading(status);
    setRepLoading(status);
  };

  useEffect(() => {
  }, []);


  const test = () => {
    apiClient.request(
      "/test/testCom",
      "GET",
      null
    ).then(res => {


    });


  }


  return (
    <div>
      <h1>Compression Example</h1>
      <Button
        type="primary"
        size="large"
        onClick={async () => {
          test();
        }}
      >测试</Button>

      <div>
        <div>
          <div className="btn-margin-right" style={{ display: 'inline-flex', alignItems: 'center', paddingBottom: 14 }}>
            <Button onClick={() => reset(false)}>关闭加载态</Button>
            <Button onClick={() => reset(true)}>开启加载态</Button>
          </div>
        </div>
        <hr />
        <Button loading={saveLoading} onClick={() => setSaveLoading(true)} style={{ marginRight: 14 }}>保存</Button>
        <Button loading={delLoading} icon={<IconDelete />} type="danger" onClick={() => setDelLoading(true)} style={{ marginRight: 14 }}>删除</Button>
        <div style={{ width: 200, display: 'inline-block' }}>
          <Button loading={repLoading} type="warning" block theme="solid" onClick={() => setRepLoading(true)}>撤销</Button>
        </div>
      </div>

    </div>
  );
}
